import { FC, MutableRefObject } from 'react';
import styles from './index.module.scss';

/**
 * Propsの定義
 * @param jobCount 求人件数のカウントアップアニメーションのref
 */
interface Props {
  jobCount: MutableRefObject<HTMLElement | null>;
}

export const JobSearchTopHeader: FC<Props> = ({ jobCount }) => {
  return (
    <div className={styles.jobSearchTopHeader}>
      <h1 className={styles.jobSearchTopHeader__title}>
        求人情報を詳細条件から探す
      </h1>
      <p className={styles.jobSearchTopHeader__jobCount}>
        この条件の求人数
        <span ref={jobCount} />件
      </p>
    </div>
  );
};
